import styled from 'styled-components/macro';
import Color from 'color2';

export const ButtonGreen = styled.button`
  min-height: 24px;
  font-family: 'Museo Sans', 'Lucida Grande', Arial, sans-serif;
  font-weight: 700;
  font-size: 12px;
  min-width: 75x;
  margin: 0 5px;
  padding: 10px 20px;
  line-height: 1.6;
  box-sizing: border-box;
  color: ${props => props.theme.global.buttonText};
  background-color: ${props => props.theme.global.green};
  border-radius: 3px;
  border: none;
  border-bottom: 2px solid ${props => props.theme.global.greenBorder};
  outline: none;
  text-transform: ${props => (props.capitalize ? 'uppercase' : 'inherit')};
  letter-spacing: 1px;
  cursor: pointer;

  &:hover {
    background-color: ${props =>
      new Color(props.theme.global.green).lighten(0.1)};
  }

  &:disabled {
    background-color: ${props =>
      new Color(props.theme.global.green).alpha(0.5)};
    cursor: not-allowed;
  }
`;

export const ButtonBlue = styled(ButtonGreen)`
  background-color: ${props => props.theme.global.blue};
  border-bottom: 1px solid ${props => props.theme.global.blueBorder};

  &:hover {
    background-color: ${props =>
      new Color(props.theme.global.blue).lighten(0.1)};
  }

  &:disabled {
    background-color: ${props => new Color(props.theme.global.blue).alpha(0.5)};
    cursor: not-allowed;
  }
`;

export default ButtonGreen;
